/* src/Interviews/cards/AvailabilityCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Modal,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import { ChevronLeft, ChevronRight, MoreHoriz } from '@material-ui/icons';

import AddLocationCard from '../../../locations/cards/AddLocationCard';
import AddTime from '../../components/AddTime';
import AvailabilityHeader from '../../components/AvailabilityHeader';
import { HeaderTable } from '../../../../app/components';

import {
  addSchedule,
  fetchSchedule,
  fetchInterviewLocations,
  updateTimeblock,
  removeTimeblock,
  updateSchedule,
  removeSchedule,
} from '../../actions';
import { removeLocation } from '../../../locations/actions';
import {
  locationNameChanged,
  locationAddressChanged,
  locationCityChanged,
  locationTypeChanged,
  locationLongitudeChanged,
  locationLatitudeChanged,
  clearLocationFields,
} from '../../../locations/cards/AddLocationCard/actions';
import { getSchedule, getUniversities, getLocations } from '../../selectors';
import { getTimestamp } from '../../../../util/dates';

import styles from './styles';

const resetInfo = { start: moment(), end: moment(), interviews: [] };
const weekdays = moment.weekdaysShort();

class AvailabilityCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      mode: 'add',
      value: 0,
      expanded: false,
      monthIndex: 0,
      weekIndex: 0,
      type: 'week',
      interviews: {},
      openEditPanel: false,
      date: moment().format('MMM D, Y'),
      start: resetInfo.start.format('HH:mm'),
      end: resetInfo.end.format('HH:mm'),
      pattern: false,
      timeblock: '',
      owner: { _id: '', name: '' },
      anchorEl: null,
      editType: 'single',
      location: { _id: '' },
      openDialog: false,
    };

    this._fetchInterviewLocations = this._fetchInterviewLocations.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._onToggleExpand = this._onToggleExpand.bind(this);
    this._onCloseLocation = this._onCloseLocation.bind(this);
    this._handleType = this._handleType.bind(this);
    this._onNext = this._onNext.bind(this);
    this._onPrev = this._onPrev.bind(this);
    this._toggleEdit = this._toggleEdit.bind(this);
    this._onAddSchedule = this._onAddSchedule.bind(this);
    this._onAddLocation = this._onAddLocation.bind(this);
    this._onMoreActions = this._onMoreActions.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onOpenEditLocation = this._onOpenEditLocation.bind(this);
    this._onRemoveLocation = this._onRemoveLocation.bind(this);
    this._onChangeStart = this._onChangeStart.bind(this);
    this._onChangeEnd = this._onChangeEnd.bind(this);
    this._handleEditType = this._handleEditType.bind(this);
    this._onClickDelete = this._onClickDelete.bind(this);
    this._onClickCancel = this._onClickCancel.bind(this);
    this._onClickSave = this._onClickSave.bind(this);
    this._onCloseDialog = this._onCloseDialog.bind(this);
  }

  componentDidMount() {
    this.props.fetchSchedule({ universities: this.props.universities });
    this._fetchInterviewLocations();
  }

  _fetchInterviewLocations() {
    this.props.fetchInterviewLocations({ universities: this.props.universities });
  }

  _onMoreActions(location) {
    return event => { this.setState({ anchorEl: event.currentTarget, location }); };
  }

  _handleChange(event, value) {
    this.setState({ value });
  }

  _handleEditType(event, value) {
    this.setState({ editType: value });
  }

  _onToggleExpand() {
    const { value } = this.state;
    if (value === 0) {
      this.setState({ expanded: !this.state.expanded });
    } else {
      this.setState({ open: true, mode: 'add' });
      this.props.locationTypeChanged('interview');
    }
  }

  _onCloseLocation() {
    this.setState({ open: false, anchorEl: null }, () => this.props.clearLocationFields());
  }

  _onAddLocation() {
    this._fetchInterviewLocations();
    this.setState(
      { open: false, anchorEl: null, location: { _id: '' } },
      () => this.props.clearLocationFields()
    );
  }

  _onRemoveLocation() {
    this.props.removeLocation({ location: this.state.location._id })
      .then(() => {
        this.setState({ anchorEl: null });
        this._fetchInterviewLocations();
      });
  }

  _onOpenEditLocation() {
    const { location: { _id } } = this.state;
    const { locationsData } = this.props;
    this.setState({ open: true, mode: 'edit' });
    const { name, address, city, coordinates: { longitude, latitude } } = locationsData[_id];
    this.props.locationTypeChanged('interview');
    this.props.locationNameChanged(name);
    this.props.locationAddressChanged(address);
    this.props.locationCityChanged(city);
    this.props.locationLongitudeChanged(longitude);
    this.props.locationLatitudeChanged(latitude);
  }

  _onChangeStart(event) {
    this.setState({ start: event.target.value });
  }
  _onChangeEnd(event) {
    this.setState({ end: event.target.value });
  }

  _handleType(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  _onNext(type) {
    return () => {
      this.setState({ [`${type}Index`]: this.state[`${type}Index`] + 1 });
    };
  }

  _onPrev(type) {
    return () => {
      this.setState({ [`${type}Index`]: this.state[`${type}Index`] - 1 });
    };
  }

  _toggleEdit(type) {
    return editInfo => {
      if (type && editInfo.owner._id !== this.props.ownID) {
        this.setState({
          openDialog: true,
          owner: editInfo.owner,
        });
        return;
      }
      this.setState({
        openEditPanel: type,
        date: editInfo.start.format('MMM D, Y'),
        start: editInfo.start.format('HH:mm'),
        end: editInfo.end.format('HH:mm'),
        pattern: editInfo.pattern,
        timeblock: editInfo._id,
        owner: editInfo.owner,
      });
    };
  }

  _onAddSchedule({ startDate, startTime, endTime, pattern }) {
    const date = moment(startDate);
    const start = startTime.split(':');
    const end = endTime.split(':');
    const d = { month: date.month(), day: date.date(), year: date.year() };
    const params = {
      input: {
        startTime: { timestamp: getTimestamp({
          ...d,
          hour: parseInt(start[0], 10),
          min: parseInt(start[1], 10),
        }) },
        endTime: { timestamp: getTimestamp({
          ...d,
          hour: parseInt(end[0], 10),
          min: parseInt(end[1], 10),
        }) },
        pattern,
      },
    };
    this.props.addSchedule(params)
      .then(() => this.props.fetchSchedule({ universities: this.props.universities }));
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _onClickDelete() {
    const { pattern, editType, timeblock } = this.state;
    let action = this.props.removeTimeblock;
    if (pattern && editType === 'all')
      action = this.props.removeSchedule;
    action({ timeblock }).then(() => {
      this.props.fetchSchedule({ universities: this.props.universities });
      this._toggleEdit(false)(resetInfo);
    });
  }

  _onClickCancel() {
    this._toggleEdit(false)(resetInfo);
  }

  _onClickSave() {
    const { pattern, start, end, editType, timeblock, date } = this.state;
    let action;
    const dt = moment(date);
    const startTime = start.split(':');
    const endTime = end.split(':');
    const d = { month: dt.month(), day: dt.date(), year: dt.year() };
    const params = { input: {
      _timeblock: timeblock,
      startDate: { timestamp: getTimestamp({
        ...d,
        hour: parseInt(startTime[0], 10),
        min: parseInt(startTime[1], 10),
      }) },
      endDate: { timestamp: getTimestamp({
        ...d,
        hour: parseInt(endTime[0], 10),
        min: parseInt(endTime[1], 10),
      }) },
    } };
    if (pattern && editType === 'all') action = this.props.updateSchedule;
    else action = this.props.updateTimeblock;
    action(params).then(() => {
      this.props.fetchSchedule({ universities: this.props.universities });
      this._toggleEdit(false)(resetInfo);
    });
  }

  _onCloseDialog() {
    this.setState({ openDialog: false });
  }

  renderSchedule(classes, type) {
    if (type === 'month') {
      const { schedule } = this.props;
      const { monthIndex } = this.state;
      const daysLastMonth = moment().add(monthIndex - 1, 'months').daysInMonth();
      const month = moment().add(monthIndex, 'months');
      const start = month.startOf('month').day();
      const daysInMonth = month.daysInMonth();
      const param = { month, start, daysLastMonth, daysInMonth, schedule };
      return (
        <React.Fragment>
          <div className={classes.header}>
            <Typography variant="body2">
              {month.format('MMMM, YYYY')}
            </Typography>
            <div className={classes.prevNextContainer}>
              <IconButton onClick={this._onPrev('month')}><ChevronLeft /></IconButton>
              <IconButton onClick={this._onNext('month')}>
                <ChevronRight />
              </IconButton>
            </div>
          </div>
          <div className={classes.gridContainer}>
            <div className={classes.grid}>
              {_.range(49).map(i => (
                <React.Fragment key={i}>
                  {this.renderCell(classes, i, param)}
                </React.Fragment>
              ))}
            </div>
          </div>
        </React.Fragment>
      );
    }
    const { schedule } = this.props;
    const { weekIndex } = this.state;
    const week = moment().add(weekIndex * 7, 'days');
    const nextWeek = moment().add((weekIndex + 1) * 7, 'days');
    return (
      <React.Fragment>
        <div className={classes.header}>
          <Typography variant="body2">
            {week.format('MMMM D, YYYY')} - {nextWeek.format('MMMM D, YYYY')}
          </Typography>
          <div className={classNames(classes.prevNextContainer, classes.pnExtend)}>
            <IconButton onClick={this._onPrev('week')}><ChevronLeft /></IconButton>
            <IconButton onClick={this._onNext('week')}>
              <ChevronRight />
            </IconButton>
          </div>
        </div>
        <div className={classes.gridContainer}>
          <div className={classes.weekGrid}>
            {_.range(7).map(i => {
                const today = moment().add(weekIndex * 7 + i, 'days');
                return (
                  <div key={weekdays[i]} className={classNames(classes.cell, classes.weekday)}>
                    <Typography variant="body2">
                      {weekdays[today.day()]} - {today.date()}
                    </Typography>
                  </div>
                );
            })}
            {_.range(7).map(i => {
              const today = moment().add(weekIndex * 7 + i, 'days');
              const key = today.format('MMM-D-YYYY');

              if (!schedule[key]) {
                return (
                  <div
                    key={key}
                    style={{ gridColumn: `${i + 1} / span 1` }}
                    className={classNames(classes.weekCell, classes.weekNone)}
                  />
                );
              }

              const { availability } = schedule[key];
              // assume that for every interview, there is an availability.
              const { length } = availability;


              const hours = _.range(length).map(j =>
                moment.duration(availability[j].end - availability[j].start)
                  .asHours());

              const tHours = hours.reduce((a, b) => a + b, 0);
              const parts = hours.map(t => _.round(t / tHours * 24));
              const total = parts.reduce((a, b) => a + b, 0);

              if (total > 24) {
                _.range(total - 24).forEach(() => {
                  parts[_.indexOf(parts, _.max(parts))]--;
                });
              } else if (total < 24) {
                _.range(23 - total).forEach(() => {
                  parts[_.indexOf(parts, _.min(parts))]++;
                });
              }
              parts[0] += 2;
              _.range(length).forEach(j => {
                if (j < length - 1) parts[j + 1] += (parts[j]);
              });
              const partition = _.concat(2, parts);

              let heightMult = tHours > 12 ? 480 / tHours : 40;
              if (tHours < 10) heightMult = 53;

              return (
                availability.map(({ start, end, interviews, ...rest }, j) => (
                  <div
                    key={`${key}-${j}`}
                    style={{
                      gridColumn: `${i + 1} / span 1`,
                      gridRow: `${partition[j]} / ${partition[j + 1]}`,
                    }}
                    className={classNames(classes.weekCell, classes.wAvail)}
                  >
                    <div
                      style={{ height: hours[j] * heightMult - 8 }}
                      className={classes.weekAvailability}
                    >
                      <Typography
                        noWrap
                        variant="body2"
                        className={classNames(classes.tinyText, classes.time)}
                        onClick={() => this._toggleEdit(true)({ start, end, interviews, ...rest })}
                      >
                        {start.format('HH:mm')} - {end.format('HH:mm')}
                      </Typography>
                      {!_.isEmpty(interviews) && (
                        <React.Fragment>
                          {interviews.map(m => (
                            <div
                              key={m}
                              style={{
                                top: 16 + moment.duration(m - start).asHours() * heightMult,
                                height: _.clamp(heightMult / 2 - 2, 25, 30),
                              }}
                              className={classes.taken}
                            >
                              <Typography variant="body2" className={classes.tinyText}>
                                {m.format('HH:mm')}
                              </Typography>
                            </div>
                          ))}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                ))
              );
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderEditModal(classes) {
    const { openEditPanel, date, start, end, editType, pattern } = this.state;
    return (
      <Modal
        open={openEditPanel}
        onClose={() => this._toggleEdit(false)(resetInfo)}
      >
        <Card className={classes.editPanel}>
          <Typography variant="subheading" className={classes.editHeader}>
            Edit Availability for {date}
          </Typography>
          <form className={classes.editTimeContainer} noValidate>
            <TextField
              id="start_time"
              label="Start Time"
              type="time"
              // defaultValue={start.format('HH:mm')}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
              value={start}
              onChange={this._onChangeStart}
            />
            <TextField
              id="edit_time"
              label="End Time"
              type="time"
              // defaultValue={end.format('HH:mm')}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 300 }}
              value={end}
              onChange={this._onChangeEnd}
            />
            {pattern && (
              <div className={classes.editOptions}>
                <FormControl component="fieldset" required>
                  <RadioGroup
                    aria-label="Edit Type"
                    name="edit-Type"
                    value={editType}
                    onChange={this._handleEditType}
                    row
                  >
                    <FormControlLabel value="single" control={<Radio color="primary" />} label="Just this one" />
                    <FormControlLabel value="all" control={<Radio color="primary" />} label="Apply to all" />
                  </RadioGroup>
                </FormControl>
              </div>
            )}
          </form>
          <Divider />
          <div className={classes.editButtonContainer}>
            <Button
              className={classes.delete}
              color="secondary"
              onClick={this._onClickDelete}
            >
              Delete
            </Button>
            <div>
              <Button onClick={this._onClickCancel}>Cancel</Button>
              <Button color="primary" onClick={this._onClickSave}>Save</Button>
            </div>
          </div>
        </Card>
      </Modal>
    );
  }

  renderCell(classes, i, params) {
    const { month, start, daysLastMonth, daysInMonth, schedule } = params;

    if (i < 7) { // first 7 cells should be weekdays
      const weekdayStyle = classNames(classes.cell, classes.weekday);
      return (
        <div className={weekdayStyle}>
          <Typography variant="body2">
            {weekdays[i]}
          </Typography>
        </div>
      );
    } else if (i < start + 7) { // days before current month
      const daysBefore =
        classNames(classes.cell, classes.day, classes.daysOutOfBounds);

      return (
        <div className={daysBefore}>
          <div className={classes.dayTextContainer}>
            <Typography variant="caption">
              {daysLastMonth - start + i - 6}
            </Typography>
          </div>
        </div>
      );
    } else if (i < daysInMonth + start + 7) { // days in the month
      const days = classNames(classes.cell, classes.day);
      const key = month.startOf('month').add(i - 7 - start, 'day')
        .format('MMM-D-YYYY');

      const isToday = moment().format('MMM-D-YYYY') === key;
      const obj = schedule[key];

      return (
        <div className={days}>
          <div className={classNames(classes.dayTextContainer, { [classes.today]: isToday })}>
            <Typography variant="body2" className={classNames({ [classes.whiteText]: isToday })}>
              {i - 6 - start}
            </Typography>
          </div>
          {(obj && obj.availability) && (
            <div className={classes.availSet}>
              <Typography noWrap variant="body2" className={classes.tinyText}>Available</Typography>
            </div>
          )}
          {(obj && !_.isEmpty(obj.interviews)) && (
            <div className={classes.hasInterview}>
              <Typography noWrap variant="body2" className={classes.tinyText}>Interview</Typography>
            </div>
          )}
        </div>
      );
    }

    const daysAfter =
      classNames(classes.cell, classes.day, classes.daysOutOfBounds);

    return ( // days after
      <div className={daysAfter}>
        <div className={classes.dayTextContainer}>
          <Typography color="textSecondary">
            {i - 6 - start - daysInMonth}
          </Typography>
        </div>
      </div>
    );
  }

  render() {
    const { classes, locations } = this.props;
    const { value, expanded, type, open, mode, anchorEl, location } = this.state;
    return (
      <Card className={classes.paper}>
        <AvailabilityHeader
          onExpand={this._onToggleExpand}
          onTab={this._handleChange}
          value={value}
          expanded={expanded}
        />
        {value === 0 && (
          <React.Fragment>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <AddTime onAddSchedule={this._onAddSchedule} />
            </Collapse>
            <div className={classes.selectWrapper}>
              <FormControl component="fieldset" required>
                <RadioGroup
                  aria-label="View Type"
                  name="type"
                  value={type}
                  onChange={this._handleType}
                  row
                >
                  <FormControlLabel value="week" control={<Radio color="primary" />} label="Week" />
                  <FormControlLabel value="month" control={<Radio color="primary" />} label="Month" />
                </RadioGroup>
              </FormControl>
            </div>
            {this.renderSchedule(classes, type)}
            {this.renderEditModal(classes)}
            <Dialog
              open={this.state.openDialog}
              onClose={this._onCloseDialog}
              aria-labelledby="alert"
              aria-describedby="alert"
            >
              <DialogTitle id="alert-title">You do not have permission to access this timeblock</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  This timeblock belongs to {(this.state.owner || { name: '' }).name}.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this._onCloseDialog} color="primary" autofocus>
                  okay
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>
        )}
        {value === 1 && (
          <React.Fragment>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <div />
            </Collapse>
            <HeaderTable
              Action={datum => (
                <IconButton onClick={this._onMoreActions(datum)}>
                  <MoreHoriz />
                </IconButton>
              )}
              data={locations}
            />
            <AddLocationCard
              ref={node => this._addLocationCard = node}
              location={location._id || ''}
              open={open}
              onClose={this._onCloseLocation}
              onSubmit={this._onAddLocation}
              removedCategories={['cafe', 'university']}
              mode={mode}
              from="interview"
            />
            <Menu
              id="location-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this._onCloseMenu}
            >
              <MenuItem onClick={this._onOpenEditLocation}>Edit</MenuItem>
              <MenuItem onClick={this._onRemoveLocation}>Delete</MenuItem>
            </Menu>
          </React.Fragment>
        )}
      </Card>
    );
  }
}

AvailabilityCard.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchSchedule: PropTypes.func.isRequired,
  fetchInterviewLocations: PropTypes.func.isRequired,
  addSchedule: PropTypes.func.isRequired,
  schedule: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  universities: PropTypes.arrayOf(PropTypes.string).isRequired,
  locationTypeChanged: PropTypes.func.isRequired,
  clearLocationFields: PropTypes.func.isRequired,
};

const mapStateToProps = ({ interviews, auth }) => ({
  ownID: auth.data.user._id,
  schedule: getSchedule(interviews),
  universities: getUniversities(auth),
  locations: getLocations(interviews),
  locationsData: interviews.locations.data,
});

const mapDispatchToProps = dispatch => ({
  addSchedule: input => dispatch(addSchedule(input)()),
  fetchSchedule: params => dispatch(fetchSchedule(params)()),
  fetchInterviewLocations: input => dispatch(fetchInterviewLocations(input)()),
  locationTypeChanged: text => dispatch(locationTypeChanged(text)),
  locationNameChanged: text => dispatch(locationNameChanged(text)),
  locationAddressChanged: text => dispatch(locationAddressChanged(text)),
  locationCityChanged: text => dispatch(locationCityChanged(text)),
  locationLongitudeChanged: params => dispatch(locationLongitudeChanged(params)),
  locationLatitudeChanged: params => dispatch(locationLatitudeChanged(params)),
  clearLocationFields: () => dispatch(clearLocationFields()),
  removeLocation: params => dispatch(removeLocation(params)()),
  updateTimeblock: params => dispatch(updateTimeblock(params)()),
  removeTimeblock: params => dispatch(removeTimeblock(params)()),
  updateSchedule: params => dispatch(updateSchedule(params)()),
  removeSchedule: params => dispatch(removeSchedule(params)()),
});

export default compose(
  withStyles(styles, { name: 'AvailabilityCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AvailabilityCard);



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/AvailabilityCard/index.js